import React, { useMemo } from 'react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { PieChart } from 'echarts/charts';
import { TooltipComponent } from 'echarts/components';
import { useAppContext } from 'providers/AppProvider';

echarts.use([TooltipComponent, PieChart]);

interface EcomTopBrandChartProps {
  summary: {
    totalProducts: number;
    soldProducts: number;
    unsoldProducts: number;
  };
}

const EcomTopBrandChart = ({ summary }: EcomTopBrandChartProps) => {
  const { getThemeColor } = useAppContext();
  const { soldProducts, unsoldProducts, totalProducts } = summary;

  const pieData = useMemo(
    () => [
      { name: 'Sold', value: soldProducts },
      { name: 'Unsold', value: unsoldProducts }
    ],
    [soldProducts, unsoldProducts]
  );

  const soldPercent = totalProducts
    ? ((soldProducts / totalProducts) * 100).toFixed(1)
    : '0';

  const chartOption = {
    color: [getThemeColor('primary'), getThemeColor('gray-400')],
    tooltip: {
      trigger: 'item',
      formatter: (params: { name: string; value: number; percent: number }) =>
        `<strong>${params.name}</strong>: ${params.value} (${params.percent}%)`
    },
    legend: {
      show: false
    },
    series: [
      {
        name: 'Product Sales',
        type: 'pie',
        radius: ['70%', '90%'],
        avoidLabelOverlap: false,
        label: {
          show: true,
          position: 'center',
          formatter: `${soldPercent}%`,
          fontSize: 18,
          fontWeight: 'bold',
          color: getThemeColor('light-text-emphasis')
        },
        labelLine: {
          show: false
        },
        itemStyle: {
          borderColor: getThemeColor('body-bg'),
          borderWidth: 2
        },
        data: pieData
      }
    ]
  };

  return (
    <ReactEChartsCore
      echarts={echarts}
      option={chartOption}
      style={{
        height: '150px',
        maxWidth: '200px',
        width: '100%'
      }}
    />
  );
};

export default EcomTopBrandChart;
